var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-area',{attrs:{"subtitle":_vm.subtitle,"color":"gestante","title":"Gestante"}},[_c('Form',{ref:"Form",attrs:{"item":_vm.data.model.gestacao || undefined,"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }